import React, { useCallback } from 'react';
import { connect } from "react-redux";
import { useTranslation } from 'react-i18next';
import UnifiedModal from '../UnifiedModal';

function PromoModal({dispatch, dir, shouldShow, setModalVisible, cid, user, onPrimaryClick, clickedItem}) {
  const { t } = useTranslation();

  const handleClose = useCallback(() => setModalVisible(false), [setModalVisible]);

  const footerButtons = [
    // {
    //   variant: 'secondary',
    //   onClick: handleClose,
    //   children: t("ImStillSearching")
    // },
    {
      onClick: () => onPrimaryClick(clickedItem),
      variant: 'primary',
      children: user ? t("enterBookingNumber") : t("loginToSave")
    }
  ];

  return (
    <UnifiedModal
      show={shouldShow}
      onHide={handleClose}
      title={t("promoTitle")}
      dir={dir}
      footerButtons={footerButtons}
    >
      <video playsInline autoPlay muted loop id="myVideo" style={{ width: '100%', height: 'auto' }}>
        <source src="/pinchi.mp4" type="video/mp4" />
      </video>
      {t("promoText")}
    </UnifiedModal>
  );
}

const mapStateToProps = ({ ui }) => ({
  dir: ui.direction,
});

export default connect(mapStateToProps)(PromoModal);